///<reference path="../../models/ManageTagsBase.ts"/>
import {Component, NgZone} from '@angular/core';
import {AlertController, Events, IonicPage, Loading, LoadingController, NavController, Platform} from 'ionic-angular';
import {VizixService} from '../../providers/vizix.service';
import {StatusBar} from '@ionic-native/status-bar';
import {TranslateService} from '@ngx-translate/core';
import {NativeAudio} from '@ionic-native/native-audio';
import {InsomniaService} from '../../providers/insomnia.service';
import {VizixEventService} from '../../providers/vizix.event.service';
import {Keyboard} from '@ionic-native/keyboard';
import {ManageTagsBase} from '../../models/ManageTagsBase';
import {EncodeTagConfiguration} from "../../models/encodeTag.config";
import {SGTIN96} from "../../models/sgtinencoding/epc-utils";
import {ReaderService} from "../../providers/reader.service";
import {EncodeTagsService} from "../../providers/encode.tags.service";
import {EncodedTag} from "../../models/EncodedTag";
import {Subscription} from "rxjs/Subscription";
import {
  EPC_SEQUENCE_UDF_ORIGINAL_EPC, EPC_SEQUENCE_UDF_UPC, EPC_SEQUENCE_UDF_ZONE,
  ITEM_UDF_USER, ITEM_UDF_UUID_MOBILE,
  RETURN_PAGE_ENCODE_TAGS, VIZIX_EVENT_GET_SERIAL_FROM_THING_ENCODE, VIZIX_EVENT_ID_UPDATE_ASSOCIATION,
  VIZIX_EVENT_WRITE_TAG,
  VizixEventAction,
  VizixEventActivity,
  VizixEventCategory,
  VizixEventEventType,
  VizixEventSubCategory
} from "../../app/app.constants";
import {PatchThingRequestItem} from "../../models/PatchThingRequestItem";
import {EPCSequenceThingService} from "../../providers/epc.sequence.thing.service";
import {EPCSequenceThing} from "../../models/EPCSequenceThing";

@IonicPage()
@Component({
  selector: 'page-encode-tags',
  templateUrl: 'encode-tags.html',
})
export class EncodeTagsPage extends ManageTagsBase {

  encoded: number;
  configEncode: EncodeTagConfiguration;
  newEpc: string;
  productSerialNumber: string;
  readerDisconnectSubscription: Subscription;

  SCHEMA_ENCODE_VIZIX = "2";

  constructor(public navCtrl: NavController,
              public vizixService: VizixService,
              public vizixEventService: VizixEventService,
              public statusBar: StatusBar,
              public alertCtrl: AlertController,
              public platform: Platform,
              public loadingCtrl: LoadingController,
              public keyBoard: Keyboard,
              public translate: TranslateService,
              public ngZone: NgZone,
              public events: Events,
              public nativeAudio: NativeAudio,
              public readerService: ReaderService,
              public encodeTagsService: EncodeTagsService,
              public ePCSequenceThingService: EPCSequenceThingService,
              public insomniaService: InsomniaService) {
    super(navCtrl, vizixService, vizixEventService, statusBar, alertCtrl, platform, loadingCtrl, keyBoard, translate, ngZone, events, nativeAudio, insomniaService);
    this.initializeComplementaryVariables();
  }

  ionViewDidLoad() {
    super.ionViewDidLoad();
    this.readerService.startStopWriteteMode(true);
  }

  ionViewWillLeave() {
    super.ionViewWillLeave();
    this.readerService.startStopWriteteMode(false);
    if (this.readerDisconnectSubscription) {
      this.readerDisconnectSubscription.unsubscribe();
    }
  }

  ionViewWillEnter() {
    super.ionViewWillEnter();
    this.initReaderStatusListener();
  }

  /**
   * Initialize class property values
   */
  initializeComplementaryVariables() {
    this.returnPage = RETURN_PAGE_ENCODE_TAGS;
    this.encoded = 0;
    this.tag = '[ENCODE_TAGS]';
    this.config = this.vizixService.configurationApp.EncodeTagConfiguration as EncodeTagConfiguration;
    this.configEncode = this.vizixService.configurationApp.EncodeTagConfiguration;
    this.TAG_TYPE = this.configEncode.FirstFieldLabel.value;
    this.newEpc = "";
    this.productSerialNumber = "";
  }

  /**
   * When form is triggered with config, first and second field values modified
   * @param {any} params
   */
  onEncodeTag(params: { config: EncodeTagConfiguration, firstField: string, secondField: string }) {
    // Update values from component
    this.config = params.config;
    this.configEncode = params.config;
    this.firstField = params.firstField;
    this.secondField = params.secondField;

    if (this.ValidateFields() && !(this.loading instanceof Loading)) {

      this.onLoading({
        content: this.translate.instant('encode_tags.loading_encoding'),
        dismissOnPageChange: true
      }).then(() => {
        this.vizixService.VizixGetThingAssociation(this.configEncode.FirstThingTypeCode.value, this.configEncode.FirstBarcodeUDF.value, this.firstField, false)
          .subscribe(
            (data: Array<any>) => {
              if (data.length > 0) // UPC (first field)  exists in Products
              {
                if (!this.getProductUDFValue(this.configEncode.DefaultProductUPCUDF.value, data[0])) {
                  this.dismissLoading();
                  this.resetForm();
                  this.onAlert({
                    type: 'error',
                    title: this.translate.instant('encode_tags.alert.error_udf_locate_product.title'),
                    message: this.translate.instant('encode_tags.alert.error_udf_locate_product.message'),
                    okButtonText: this.translate.instant('manage_tags.buttons.ok')
                  });
                } else {
                  this.encodeverifySecondFieldExist();
                }
              }
              else {
                this.dismissLoading();
                this.resetForm();
                this.onAlert({
                  type: 'error',
                  title: this.translate.instant('encode_tags.alert.error_locate_product.title'),
                  message: this.translate.instant('encode_tags.alert.error_locate_product.message'),
                  okButtonText: this.translate.instant('manage_tags.buttons.ok')
                });
              }
            },
            error => {
              this.dismissLoading();
              this.resetForm();
              this.onAlert({
                type: 'error',
                title: this.translate.instant('encode_tags.alert.error_unexpected.title'),
                message: this.translate.instant('encode_tags.alert.error_unexpected.message'),
                okButtonText: this.translate.instant('manage_tags.buttons.ok')
              });
            });
      });
    }
  }

  /*Encode the firstField and Verify the existence of the new tag generated*/
  private encodeverifySecondFieldExist() {

    // Encoding Tag
    let epcUtils = new SGTIN96();

    this.getSerialNumer(this.configEncode.EncodeSchema.value == this.SCHEMA_ENCODE_VIZIX, this.firstField, this.secondField)
      .then(
        (serialNumberEncode) => {
          try {
            let bigInt = require('big-integer');
            let number;

            if (this.configEncode.ConvertSerialToHex.value) {
              number = bigInt(serialNumberEncode, 10);
            } else {
              number = bigInt(serialNumberEncode, 16);
            }

            let newEpcSGTIN96 = epcUtils.fromUPCwithValues(this.firstField,
              this.configEncode.CompanyPrefixLenght.value,
              Number(this.configEncode.Partition.value),
              Number(this.configEncode.HeaderValue.value),
              Number(this.configEncode.EncodeFilterValue.value),
              number);

            newEpcSGTIN96.setHeader(Number(this.configEncode.HeaderValue.value));
            this.newEpc = newEpcSGTIN96.ToEpc().toUpperCase();
            // saving event Create encode tag
            let detailsMessage = "New Epc Encoded: " + this.newEpc;
            this.generateAndSaveVizixEvent(null, VizixEventActivity.ENCODE_TAG, VIZIX_EVENT_WRITE_TAG, this.vizixService.configurationApp.EncodeTagConfiguration.ThingTypeCodeToSync.value, false, "", detailsMessage, VizixEventAction.CREATE_ENCODE_TAG);
            // Verifying new EPC Existence
            this.vizixService.VizixGetThingAssociation(
              this.configEncode.SecondThingTypeCode.value,
              this.configEncode.SecondBarcodeUDF.value,
              this.newEpc,
              true)
              .subscribe(
                (data: any) => {
                  if (data.length > 0) // EPC (second field) exist in Items
                  {
                    this.dismissLoading();
                    this.onAlert({
                      type: 'error',
                      title: this.translate.instant('encode_tags.alert.error_override_forbidden.title'),
                      message: this.translate.instant('encode_tags.alert.error_override_forbidden.message'),
                      okButtonText: this.translate.instant('manage_tags.buttons.ok')
                    });
                    this.resetForm();
                  }
                  else {
                    this.WriteNewEPC(serialNumberEncode);
                  }
                },
                error => {
                  this.dismissLoading();
                  this.resetForm();
                  this.onAlert({
                    type: 'error',
                    title: this.translate.instant('encode_tags.alert.error_unexpected.title'),
                    message: this.translate.instant('encode_tags.alert.error_unexpected.message'),
                    okButtonText: this.translate.instant('manage_tags.buttons.ok')
                  });
                  console.log(this.tag, error);
                });
          }
          catch (ex) {
            this.generateAndSaveVizixEvent(null, VizixEventActivity.ENCODE_TAG, VIZIX_EVENT_WRITE_TAG, this.vizixService.configurationApp.EncodeTagConfiguration.ThingTypeCodeToSync.value, true, ex, "", VizixEventAction.CREATE_ENCODE_TAG);
            this.dismissLoading();
            this.resetForm();
            this.onAlert({
              type: 'error',
              title: this.translate.instant('encode_tags.alert.error_encode_tag.title'),
              message: this.translate.instant('encode_tags.alert.error_encode_tag.message') + ex,
              okButtonText: this.translate.instant('manage_tags.buttons.ok')
            });
          }
        },
        (error) => {
          this.dismissLoading();
          this.resetForm();
          this.onAlert({
            type: 'error',
            title: this.translate.instant('encode_tags.alert.error_getting_serial.title'),
            message: this.translate.instant('encode_tags.alert.error_getting_serial.message'),
            okButtonText: this.translate.instant('manage_tags.buttons.ok')
          });
          console.log(this.tag, "error getting serial number to encode ", error);
        });


  }

  /* Override the new EPC to the old and Save the association with the new EPC in VIZIX */
  private WriteNewEPC(serialNumberEncode: string) {
    console.log(this.tag, "target tag", this.secondField);
    console.log(this.tag, "new tag", this.newEpc);
    console.log(this.tag, "pwd", this.configEncode.WritePassword.value);
    let encodTagModel = new EncodedTag(this.secondField, this.productSerialNumber, this.newEpc, this.selectedZone, Date.now());
    let epcSequence = new EPCSequenceThing(serialNumberEncode, this.newEpc, Date.now(), this.vizixService.configurationApp.AppParametersConfiguration.Group.value);
    //saving event of write tag
    let isError = false; // To control the events in case of error
    let errorMessage = null; // To control the events in case of error

    //save encode Tag on Vizix
    this.readerService.changeAndWriteMode(this.secondField, this.newEpc, this.configEncode.WritePassword.value).subscribe(
      (result) => {
        console.log(this.tag, "success writing", result);
        this.encodeTagsService.saveEncodedTag(encodTagModel).then(
          (save) => {
            this.dismissLoading();
            if (this.isSoundAssociationReady) {
              this.nativeAudio.play(this.soundAssociation);
            }
            this.ngZone.run(() => {
              this.encoded++;
            });

            let message = "";
            if (save) {
              // save online
              message = this.translate.instant('encode_tags.alert.encoded_success.message');
            } else {
              // save locally
              message = this.translate.instant('encode_tags.alert.encoded_success.message_locally');
            }

            message = message.replace("${label_first_field}", this.configEncode.FirstFieldLabel.value);
            message = message.replace("${value_first_field}", this.firstField);
            message = message.replace("${label_second_field}", this.configEncode.SecondFieldLabel.value);
            message = message.replace("${value_second_field}", this.secondField);
            message = message.replace("${value_encoded}", this.newEpc);

            this.onAlert({
              type: 'alert',
              title: this.translate.instant('encode_tags.alert.encoded_success.title'),
              message: message,
              callback: () => this.resetForm(),
              okButtonText: this.translate.instant('manage_tags.buttons.ok')
            });
          },
          () => {
            this.dismissLoading();
            this.resetForm();
            this.onAlert({
              type: 'error',
              title: this.translate.instant('encode_tags.alert.error_unexpected.title'),
              message: this.translate.instant('encode_tags.alert.error_unexpected.message'),
              okButtonText: this.translate.instant('manage_tags.buttons.ok')
            });
          }
        );

        if (this.configEncode.EncodeSchema.value == this.SCHEMA_ENCODE_VIZIX) {
          this.ePCSequenceThingService.saveEPCSequenceThing(epcSequence).then(
            (save) => {
              if (save) {
                console.log(this.tag, "Update EPCSequenceThing successfull");
              } else {
                console.log(this.tag, "Update EPCSequenceThing successfull Locally");
              }
            },
            () => {
              //TODO add the Method to control reject.
            }
          );
        }
      },
      (error) => {
        isError = true;
        errorMessage = error;
        this.dismissLoading();
        this.onAlert({
          type: 'cancel',
          title: this.translate.instant('encode_tags.alert.error_writing_tag.title'),
          message: error.message,
          okButtonText: this.translate.instant('encode_tags.alert.error_writing_tag.retry_button'),
          callback: () => this.retryToWriteNewEPC(serialNumberEncode),
          cancelButtonText: this.translate.instant('encode_tags.alert.error_writing_tag.cancel_button')
        });
      }, () => {
        if (!isError) {
          let detailsMessage = {
            product: encodTagModel.productSerial,
            oldItem: encodTagModel.secondField,
            item: encodTagModel.newEpc
          };
          this.generateAndSaveVizixEvent(encodTagModel, VizixEventActivity.ENCODE_TAG, VIZIX_EVENT_WRITE_TAG, this.vizixService.configurationApp.EncodeTagConfiguration.ThingTypeCodeToSync.value, false, "", detailsMessage, VizixEventAction.WRITE_TAG);
        } else {
          this.generateAndSaveVizixEvent(encodTagModel, VizixEventActivity.ENCODE_TAG, VIZIX_EVENT_WRITE_TAG, this.vizixService.configurationApp.EncodeTagConfiguration.ThingTypeCodeToSync.value, true, errorMessage, "", VizixEventAction.WRITE_TAG);
        }
      }
    );
  }

  retryToWriteNewEPC(serialNumberEncode: string) {
    this.onLoading({
      content: this.translate.instant('encode_tags.loading_retry_writing'),
      dismissOnPageChange: true
    }).then(() => {
        this.WriteNewEPC(serialNumberEncode);
      }
    );

  }

  /**
   * Get serial number to encode tag from a Expression
   * @param {string} secondField
   * @returns {string}
   */
  private getSerialNumberEncodeExpression(secondField: string): string {
    return secondField.match(this.configEncode.ValueExpression.value)[0];
  }

  /**
   * Get Product UDF Value
   * @param {string} UDFName
   * @param productFromVizix
   * @returns {boolean}
   */
  private getProductUDFValue(UDFName: string, productFromVizix: any): boolean {
    if (productFromVizix[UDFName]) {
      this.productSerialNumber = productFromVizix[UDFName];
    } else {
      this.productSerialNumber = '';
      return false;
    }
    return true;
  }

  /* Init the reader listener to determinate if the reader disconnect*/
  private initReaderStatusListener() {
    console.log(this.tag, 'Initializing Reader Status Listener');
    this.readerDisconnectSubscription = this.readerService.setStatusListener().subscribe(
      (response) => {
        console.log(this.tag, 'Reader status', response);
        if (response.hasOwnProperty('connected') && !response.connected) {
          console.log(this.tag, 'Reader disconnected!');
          this.dismissAlert();
          this.onAlert({
            type: 'error',
            title: this.translate.instant('encode_tags.alert.reader_disconnected.title'),
            message: this.translate.instant('encode_tags.alert.reader_disconnected.message'),
            okButtonText: this.translate.instant('manage_tags.buttons.ok'),
            callback: () => {
              this.navCtrl.pop();
            }
          });
        }
      }, (error) => {
        this.dismissAlert();
        this.onAlert({
          type: 'error',
          title: this.translate.instant('encode_tags.alert.reader_error.title'),
          message: this.translate.instant('encode_tags.alert.reader_error.message'),
          okButtonText: this.translate.instant('manage_tags.buttons.ok')
        });
      });
  }

  private ValidateFields(): boolean {
    if (!this.selectedZone) {
      this.onAlert({
        type: 'error',
        title: this.translate.instant('encode_tags.alert.validation_error.title'),
        message: this.translate.instant('encode_tags.alert.validation_error.selected_zone'),
        okButtonText: this.translate.instant('manage_tags.buttons.ok')
      });
      return false;
    }
    if (isNaN(parseInt(this.getSerialNumberEncodeExpression(this.secondField), 16))) {
      this.onAlert({
        type: 'error',
        title: this.translate.instant('encode_tags.alert.validation_error.title'),
        message: this.translate.instant('encode_tags.alert.validation_error.serial_number'),
        okButtonText: this.translate.instant('manage_tags.buttons.ok')
      });
      return false;
    }
    return true;
  }

  /**
   * Generate and save vizix event
   *
   * @param {VizixEventActivity} activity
   * @param {string} eventId
   * @param {string} thingTypeCode
   * @param {string} firstFieldText
   * @param {string} secondFieldText
   * @param {boolean} isError
   * @param {string} errorMessage
   */
  private generateAndSaveVizixEvent(encodedTag: EncodedTag,
                                    activity: VizixEventActivity,
                                    eventId: string,
                                    thingTypeCode: string,
                                    isError?: boolean,
                                    errorMessage?: string,
                                    detailMessage?: any,
                                    action?: VizixEventAction) {
    this.vizixEventService.getVizixEventItemBase(isError).then((vizixEvent) => {
      vizixEvent.category = VizixEventCategory.WORKFLOW;
      vizixEvent.subCategory = VizixEventSubCategory.ENCODE_TAG;
      vizixEvent.eventType = VizixEventEventType.INFO;
      vizixEvent.activity = activity;
      if (action) {
        vizixEvent.action = action;
      }
      if (isError) {
        vizixEvent.detail = this.vizixEventService.generateDetailsMessage(errorMessage,
          thingTypeCode, thingTypeCode, this.vizixService.configurationApp.AppParametersConfiguration.DefaultDepartment.value, this.selectedZone.name);
      } else {
        vizixEvent.detail = this.vizixEventService.generateDetailsMessage(detailMessage,
          thingTypeCode, thingTypeCode, this.vizixService.configurationApp.AppParametersConfiguration.DefaultDepartment.value, this.selectedZone.name);

      }

      vizixEvent.count = 1;
      vizixEvent.eventId = eventId;
      this.vizixEventService.recordEvent(vizixEvent);
    }, (error) => {
      console.log(this.tag, 'Error getting VizixItemBase', error);
    });
  }


  /**
   *  Generate serial number to encode tag from Vizix
   * @param {string} firstField
   * @param {string} secondField
   * @returns {Promise<string>}
   */
  private getSerialNumberEncodeFromVizix(firstField: string, secondField: string): Promise<string> {
    // creating thing in vizix
    let body: PatchThingRequestItem[] = [];
    let requestItem = new PatchThingRequestItem();

    requestItem.timestamp = Date.now();
    requestItem.serialNumber = '';
    requestItem.name = '';
    requestItem.group = this.vizixService.configurationApp.AppParametersConfiguration.Group.value;
    requestItem.thingTypeCode = this.configEncode.EncodeSerialThingTypeCode.value;
    requestItem.udfs = {};
    requestItem.udfs[EPC_SEQUENCE_UDF_ORIGINAL_EPC] = {'value': secondField};
    requestItem.udfs[EPC_SEQUENCE_UDF_UPC] = {'value': firstField};
    requestItem.udfs[ITEM_UDF_USER] = {value: this.username};
    requestItem.udfs[ITEM_UDF_UUID_MOBILE] = {value: this.uuid};
    requestItem.udfs[EPC_SEQUENCE_UDF_ZONE] = {value: String(this.vizixService.getStoreId()) + '_' + this.selectedZone.zoneTypeCode};
    body.push(requestItem);

    let isError = false; // To control the events in case of error
    let errorMessage = null; // To control the events in case of error
    let newSerialNumberEncode;
    return new Promise<string>((resolve, reject) => {
      this.vizixService.VizixPatchItem(body, {'upsert': 'true'}).subscribe(
        (data: any) => {
          if (data == null || typeof data == "undefined" || Object.keys(data).length <= 0 || data[Object.keys(data)[0]].ERROR) {
            data[Object.keys(data)[0]].ERROR ? reject(data[Object.keys(data)[0]].ERROR) : reject(data);
          } else {
            newSerialNumberEncode = Object.keys(data)[0];
            resolve(newSerialNumberEncode);
          }
        },
        (err) => {
          isError = true;
          errorMessage = err;
          reject(err);
        },
        () => {
          if (!isError) {
            let detailMessage = "New Serial created: " + newSerialNumberEncode;
            this.generateAndSaveVizixEvent(null, VizixEventActivity.ENCODE_TAG, VIZIX_EVENT_GET_SERIAL_FROM_THING_ENCODE, this.configEncode.ThingTypeCodeToSync.value, false, "", detailMessage, VizixEventAction.GET_SERIAL_FROM_THING);
          } else {
            this.generateAndSaveVizixEvent(null, VizixEventActivity.ENCODE_TAG, VIZIX_EVENT_GET_SERIAL_FROM_THING_ENCODE, this.configEncode.ThingTypeCodeToSync.value, true, errorMessage, "", VizixEventAction.GET_SERIAL_FROM_THING);
          }
        });
    });
  }

  /**
   * Select method to generate serial number from Vizix or with a expression
   * @param {boolean} fromVizix
   * @param {string} firstField
   * @param {string} secondField
   * @returns {Promise<string>}
   */
  private getSerialNumer(fromVizix: boolean, firstField: string, secondField: string): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      if (fromVizix) {
        this.getSerialNumberEncodeFromVizix(firstField, secondField).then((newSerialNumber) => {
          resolve(newSerialNumber);
        }, (error) => {
          reject(error);
        });
      }
      else {
        resolve(this.getSerialNumberEncodeExpression(secondField));
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/encode-tags/encode-tags.ts